<script setup>
import Button from "@/components/ui/button/Button.vue";
import Empty from "@/components/ui/empty/Empty.vue";
import EmptyContent from "@/components/ui/empty/EmptyContent.vue";
import EmptyDescription from "@/components/ui/empty/EmptyDescription.vue";
import EmptyHeader from "@/components/ui/empty/EmptyHeader.vue";
import EmptyMedia from "@/components/ui/empty/EmptyMedia.vue";
import EmptyTitle from "@/components/ui/empty/EmptyTitle.vue";
import { MonitorOff } from "lucide-vue-next";
import { useRouter } from "vue-router";

const router = useRouter();

const props = defineProps({
  isLoggedIn: Boolean
})
function routeEvents(){
  router.push({ name: "Home" })
}
function routeProfile(){
  router.push({ name: "Profile" })
}

</script>

<template>
  <Empty>
    <EmptyHeader>
      <EmptyMedia variant="icon">
        <MonitorOff />
      </EmptyMedia>
      <EmptyTitle>No Bookings Yet</EmptyTitle>
      <EmptyDescription> You haven't booked anything yet. </EmptyDescription>
    </EmptyHeader>
    <EmptyContent>
      <div class="flex gap-2">
        <!-- This one to event home page -->
        <Button v-if="props.isLoggedIn" @click="routeEvents">Sign Up To Events</Button>
        <!-- this one to profile page -->
        <Button v-if="!props.isLoggedIn" @click="routeProfile"> Log In </Button>
      </div>
    </EmptyContent>
  </Empty>
</template>
